import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Status } from "@chessalpha/core";
import { Box, Button, Dialog } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
export const VideoHelp = ({ status }) => {
    const { t } = useTranslation("VideoHelp");
    const [open, setOpen] = useState(false);
    if (!status ||
        status === Status.CREATED ||
        status === Status.ACCEPTED ||
        status === Status.STARTED ||
        status === Status.ABORTED ||
        status === Status.STOPPED ||
        status === Status.UNKNOWN) {
        return null;
    }
    const actionText = t(`video.${status}`);
    const videoId = t(`video.${status}`);
    if (!actionText || !videoId) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(Button, { variant: "contained", onClick: () => setOpen(true), children: t(`action.${status}`) }), _jsx(Dialog, { open: open, onClose: () => setOpen(false), sx: { height: "auto" }, PaperProps: {
                    sx: ({ breakpoints }) => ({
                        background: "#000",
                        paddingBottom: "56.25%",
                        width: "100%",
                        maxWidth: "100%",
                        [breakpoints.up("sm")]: {
                            maxWidth: "80%",
                            paddingBottom: "calc(56.25% * 0.8)",
                        },
                    }),
                }, children: _jsx(Box, { component: "iframe", frameBorder: "0", allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true, src: videoId &&
                        `https://www.youtube.com/embed/${videoId}?autoplay=1&amp;modestbranding=1`, sx: {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                    } }) })] }));
};
//# sourceMappingURL=VideoHelp.js.map